import { render, staticRenderFns } from "./PlayListTable.vue?vue&type=template&id=10b684e8&scoped=true"
import script from "./PlayListTable.vue?vue&type=script&lang=js"
export * from "./PlayListTable.vue?vue&type=script&lang=js"
import style0 from "./PlayListTable.vue?vue&type=style&index=0&id=10b684e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b684e8",
  null
  
)

export default component.exports